"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8285],{

/***/ 6513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ AutoRefillToggle_AutoRefillToggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(833);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 40 modules
var esm = __webpack_require__(76395);
// EXTERNAL MODULE: ./design_system/components/Modal/index.ts + 3 modules
var Modal = __webpack_require__(73451);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./design_system/components/Toggle/index.ts + 2 modules
var Toggle = __webpack_require__(30831);
// EXTERNAL MODULE: ./src/utils/getNameProp.ts
var getNameProp = __webpack_require__(44873);
;// CONCATENATED MODULE: ./components/AutoRefillToggle/AutoRefillToggle.tsx










var AutoRefillToggle = function(_param) {
    var isAutoRefill = _param.isAutoRefill, onToggle = _param.onToggle, isShowConfirmation = _param.isShowConfirmation, disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isAutoRefill",
        "onToggle",
        "isShowConfirmation",
        "disabled"
    ]);
    var t = (0,esm/* useTranslation */.$G)([
        "plan",
        "common",
        "meds_selection"
    ]).t;
    var confirmModalTransPath = "common:modal.auto_renew_confirm.".concat(isAutoRefill ? "manual" : "auto");
    var btnTransPath = "common:modal.button";
    var ref = (0,index_esm/* useDisclosure */.qY)(), isOpenConfirm = ref.isOpen, onCloseConfirm = ref.onClose, onOpenConfirm = ref.onOpen;
    var handleToggle = function() {
        if (isShowConfirmation) {
            onOpenConfirm();
        } else {
            onToggle();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                justify: "space-between",
                align: "center"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, {
                        flexDir: "column",
                        mt: 3,
                        mr: 3,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                    textStyle: "body1",
                                    children: t("meds_selection:section.auto_refill.toggle_title")
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                textStyle: "body3",
                                children: t("renewal_mode.desc.".concat(isAutoRefill ? "on" : "off"), {
                                    defaultValue: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle/* ToggleCheckbox */.j, (0,_object_spread/* default */.Z)({
                        isChecked: isAutoRefill,
                        onChange: handleToggle,
                        disabled: disabled
                    }, (0,getNameProp/* default */.Z)("plan-auto-renewal-switch")))
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ConfirmModal */.sm, {
                isOpen: isOpenConfirm,
                onClose: onCloseConfirm,
                onConfirmClick: function() {
                    onToggle();
                    onCloseConfirm();
                },
                confirmText: t("".concat(btnTransPath, ".confirm")),
                title: t("".concat(confirmModalTransPath, ".title")),
                body: t("".concat(confirmModalTransPath, ".description")),
                isHideCancel: true
            })
        ]
    });
};
/* harmony default export */ var AutoRefillToggle_AutoRefillToggle = (AutoRefillToggle);

;// CONCATENATED MODULE: ./components/AutoRefillToggle/index.ts




/***/ }),

/***/ 69070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CashbackMessage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var lodash_fp_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59051);
/* harmony import */ var lodash_fp_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_isNil__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1922);
/* harmony import */ var design_system_components_OFText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92757);
/* harmony import */ var src_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52269);
/* harmony import */ var src_utils_priceFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69240);










var CashbackMessage = function(_param) {
    var cashbackAmount = _param.cashbackAmount, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "cashbackAmount"
    ]);
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    if (lodash_fp_isNil__WEBPACK_IMPORTED_MODULE_0___default()(cashbackAmount) || Number.isNaN(cashbackAmount)) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        flexDir: "column",
        w: "100%",
        mb: 4,
        gap: 1
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_2__/* .OFText */ .o, {
                        textStyle: "body3",
                        color: src_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.black[900] */ .O.black[900],
                        children: t("prescription_checkout:cashback_earn_rate_message")
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_2__/* .OFText */ .o, {
                        textStyle: "body3",
                        color: src_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.black[900] */ .O.black[900],
                        children: (0,src_utils_priceFormat__WEBPACK_IMPORTED_MODULE_4__/* .formatPrice */ .T)(cashbackAmount)
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_2__/* .OFText */ .o, {
                textStyle: "body4",
                color: src_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.grey[900] */ .O.grey[900],
                children: t("prescription_checkout:cashback_usage_message")
            })
        ]
    }));
};


/***/ }),

/***/ 11879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkout_InputCounter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./design_system/components/IconButton/index.ts + 2 modules
var IconButton = __webpack_require__(95892);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./design_system/icons/MinusIcon.tsx
var MinusIcon = __webpack_require__(65986);
// EXTERNAL MODULE: ./design_system/icons/PlusIcon.tsx
var PlusIcon = __webpack_require__(87949);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./design_system/components/OFQuantityCounter/OFQuantityCounter.tsx









var iconSize = 30;
var buttonSize = 40;
var buttonProps = {
    h: "".concat(buttonSize, "px"),
    w: "".concat(buttonSize, "px"),
    minW: "".concat(buttonSize, "px"),
    variant: "secondary"
};
var OFQuantityCounter = function(_param) {
    var number = _param.number, onMinusClick = _param.onMinusClick, onPlusClick = _param.onPlusClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "number",
        "onMinusClick",
        "onPlusClick"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        p: "6px 8px",
        alignItems: "center",
        gap: "10px",
        borderColor: colors/* colors.grey.500 */.O.grey[500],
        border: "1px solid",
        borderRadius: "8px"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                arialLabel: "Minus"
            }, buttonProps), {
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinusIcon/* default */.Z, {
                    size: iconSize
                }),
                onClick: onMinusClick
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                textStyle: "body3",
                color: colors/* colors.black.900 */.O.black[900],
                children: number
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                arialLabel: "Plus"
            }, buttonProps), {
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusIcon/* default */.Z, {
                    size: iconSize,
                    onClick: onPlusClick
                })
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./design_system/components/OFQuantityCounter/index.ts


// EXTERNAL MODULE: ./src/states/index.ts + 11 modules
var states = __webpack_require__(64443);
;// CONCATENATED MODULE: ./components/Checkout/InputCounter.tsx










var InputCounter = function(_param) {
    var onQuantityChange = _param.onQuantityChange, quantity = _param.quantity, itemProps = (0,_object_without_properties/* default */.Z)(_param, [
        "onQuantityChange",
        "quantity"
    ]);
    var ref = (0,react.useState)(quantity), stateQuantity = ref[0], setQuantity = ref[1];
    var promoCode = (0,es/* useRecoilValue */.sJ)(states/* promoCodeState */.FZ);
    var setDisabledCheckoutButtons = (0,es/* useSetRecoilState */.Zl)(states/* areDisabledCheckoutButtonsState */.jR);
    var cartItemId = itemProps.sysId, _product = itemProps.product, productId = _product.id;
    var onQuantityChangeDebounce = (0,react.useMemo)(function() {
        return (0,fp.debounce)(1000, function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(currentStateQuantity) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (quantity !== currentStateQuantity) {
                                onQuantityChange({
                                    cartItemId: cartItemId,
                                    productId: productId,
                                    quantity: currentStateQuantity
                                });
                                setDisabledCheckoutButtons(false);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(currentStateQuantity) {
                return _ref.apply(this, arguments);
            };
        }());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cartItemId,
        productId,
        quantity,
        promoCode
    ]);
    var onMinusClick = function() {
        if (stateQuantity > 1) {
            setDisabledCheckoutButtons(true);
        }
        setQuantity(stateQuantity > 1 ? stateQuantity - 1 : 1);
    };
    var onPlusClick = function() {
        setDisabledCheckoutButtons(true);
        setQuantity(stateQuantity + 1);
    };
    (0,react.useEffect)(function() {
        onQuantityChangeDebounce(stateQuantity);
    }, [
        stateQuantity,
        onQuantityChangeDebounce
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFQuantityCounter, {
            onMinusClick: onMinusClick,
            onPlusClick: onPlusClick,
            number: stateQuantity
        })
    });
};
/* harmony default export */ var Checkout_InputCounter = (InputCounter);


/***/ }),

/***/ 60599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OrderSummary_CheckoutDueSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(833);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__(36158);
;// CONCATENATED MODULE: ./components/PrescriptionFlow/TreatmentSummaryContent/PriceLoadingSkeleton.tsx





var defaultWidth = "120px";
var PriceLoadingSkeleton = function(_param) {
    var children = _param.children, isLoading = _param.isLoading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(skeleton_dist_index_esm/* Skeleton */.Od, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isLoaded: !isLoading,
        h: "24px",
        minW: defaultWidth,
        maxW: defaultWidth,
        w: defaultWidth
    }, props), {
        children: children
    }));
};

// EXTERNAL MODULE: ./design_system/components/Modal/index.ts + 3 modules
var Modal = __webpack_require__(73451);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./design_system/icons/InfoEllipseIcon.tsx
var InfoEllipseIcon = __webpack_require__(54875);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
// EXTERNAL MODULE: ./src/utils/priceFormat.ts + 1 modules
var priceFormat = __webpack_require__(69240);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/constant/style.ts
var style = __webpack_require__(63102);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/CheckoutDueSection.tsx














var CheckoutDueSection = function(_param) {
    var price = _param.price, shouldChargeNow = _param.shouldChargeNow, isLoading = _param.isLoading, _isEDBundle = _param.isEDBundle, isEDBundle = _isEDBundle === void 0 ? false : _isEDBundle, isHideInfo = _param.isHideInfo, props = (0,_object_without_properties/* default */.Z)(_param, [
        "price",
        "shouldChargeNow",
        "isLoading",
        "isEDBundle",
        "isHideInfo"
    ]);
    var checkoutTransKey = (0,utils/* addTransSuffixCountry */.WZ)("checkout");
    var t = (0,es/* useTranslation */.$G)(checkoutTransKey).t;
    var ref = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var canShowInfoIcon = !isHideInfo && (isEDBundle || !shouldChargeNow);
    var infoModal = {
        title: isEDBundle ? t("".concat(checkoutTransKey, ":ed-trial-bundle-info.title")) : t("checkout:warning-modal-if-prescribed.title"),
        body: isEDBundle ? t("".concat(checkoutTransKey, ".ed-trial-bundle-info.description")) : t("checkout:warning-modal-if-prescribed.p1")
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        justify: "space-between",
        align: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: style/* LABEL_TEXT_STYLE */.Fj,
                        children: t("".concat(checkoutTransKey, ":").concat(shouldChargeNow ? "due-now" : "pending-doctor-confirmation"))
                    }),
                    canShowInfoIcon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoEllipseIcon/* default */.Z, {
                                color: colors/* colors.grey.800 */.O.grey[800],
                                size: 20,
                                onClick: onOpen,
                                cursor: "pointer"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* InfoModal */.nv, {
                                isOpen: isOpen,
                                onClose: onClose,
                                title: infoModal.title,
                                body: infoModal.body
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceLoadingSkeleton, {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                    whiteSpace: "pre",
                    textAlign: "right",
                    color: shouldChargeNow ? colors/* colors.black.900 */.O.black[900] : colors/* colors.grey.700 */.O.grey[700],
                    textStyle: style/* VALUE_TEXT_STYLE */.Ee,
                    children: (0,priceFormat/* formatPrice */.T)(price)
                })
            })
        ]
    }));
};
/* harmony default export */ var OrderSummary_CheckoutDueSection = (CheckoutDueSection);


/***/ }),

/***/ 18285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ CheckoutSummaryInfo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./components/Cashback/CashbackMessage.tsx
var CashbackMessage = __webpack_require__(69070);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./src/constants/Countries.ts
var Countries = __webpack_require__(73252);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/DueNowRow.tsx
var DueNowRow = __webpack_require__(91444);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(4480);
// EXTERNAL MODULE: ./components/Common/PriceModal/PriceModal.tsx
var PriceModal = __webpack_require__(96165);
// EXTERNAL MODULE: ./components/hooks/Cart/useCartHooks.ts
var useCartHooks = __webpack_require__(95979);
// EXTERNAL MODULE: ./src/states/index.ts + 11 modules
var states = __webpack_require__(64443);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
// EXTERNAL MODULE: ./components/Checkout/WarningRenewModal.tsx
var WarningRenewModal = __webpack_require__(46653);
// EXTERNAL MODULE: ./components/Checkout/utils.ts
var Checkout_utils = __webpack_require__(76842);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 40 modules
var esm = __webpack_require__(76395);
// EXTERNAL MODULE: ./design_system/components/Modal/index.ts + 3 modules
var Modal = __webpack_require__(73451);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/Modal/RemoveCartItemModal.tsx






var RemoveCartItemModal = function(param) {
    var onConfirmClick = param.onConfirmClick;
    var t = (0,esm/* useTranslation */.$G)("checkout").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,recoil_es/* useRecoilState */.FV)(states/* modalCancelingItemState */.mq), 2), modalCancelingItem = ref[0], setModalCancelingItem = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,recoil_es/* useRecoilState */.FV)(states/* isCancelModalRemovingState */.Vz), 1), isRemoving = ref1[0];
    var transPath = "modal.remove-cart-item";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ConfirmModal */.sm, {
        body: t("".concat(transPath, ".title")),
        confirmText: t("".concat(transPath, ".button.confirm")),
        cancelText: t("".concat(transPath, ".button.cancel")),
        isOpen: !!modalCancelingItem,
        onClose: function() {
            return setModalCancelingItem(null);
        },
        onConfirmClick: function() {
            return onConfirmClick(modalCancelingItem);
        },
        isLoading: isRemoving
    });
};
/* harmony default export */ var Modal_RemoveCartItemModal = (RemoveCartItemModal);

;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/Modal/index.ts



// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/AutoRefillToggle/index.ts + 1 modules
var AutoRefillToggle = __webpack_require__(6513);
// EXTERNAL MODULE: ./components/Common/CountryComponentWrapper.tsx
var CountryComponentWrapper = __webpack_require__(8294);
// EXTERNAL MODULE: ./components/PrescriptionFlow/TreatmentSummaryContent/SummaryItemWrapper.tsx
var SummaryItemWrapper = __webpack_require__(92866);
// EXTERNAL MODULE: ./components/constants.ts
var constants = __webpack_require__(31606);
// EXTERNAL MODULE: ./design_system/components/IconButton/index.ts + 2 modules
var IconButton = __webpack_require__(95892);
// EXTERNAL MODULE: ./design_system/icons/TrashcanIcon.tsx
var TrashcanIcon = __webpack_require__(76013);
// EXTERNAL MODULE: ./design_system/icons/EditIcon.tsx
var EditIcon = __webpack_require__(40728);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/constants/url.constants.ts
var url_constants = __webpack_require__(97479);
// EXTERNAL MODULE: ./src/hooks/index.ts + 13 modules
var hooks = __webpack_require__(18467);
// EXTERNAL MODULE: ./src/utils/checkCountry.ts
var checkCountry = __webpack_require__(42304);
// EXTERNAL MODULE: ./src/utils/priceFormat.ts + 1 modules
var priceFormat = __webpack_require__(69240);
// EXTERNAL MODULE: ./components/Checkout/InputCounter.tsx + 2 modules
var InputCounter = __webpack_require__(11879);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/OrderSummaryItemHeader.tsx
var OrderSummaryItemHeader = __webpack_require__(56598);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/OrderSummaryItemWrapper.tsx
var OrderSummaryItemWrapper = __webpack_require__(89469);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./design_system/components/Toggle/index.ts + 2 modules
var Toggle = __webpack_require__(30831);
;// CONCATENATED MODULE: ./components/Checkout/PriceSwitch.tsx






var PriceSwitch = function(_param) {
    var onToggle = _param.onToggle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onToggle"
    ]);
    var canToggle = props.isSubscriptionPrice, type = props.price.type;
    var hasToggle = !(0,fp.isNil)(canToggle);
    var isSubscriptionPrice = type === generated.StripePriceType.Recurring;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
        margin: "1px",
        opacity: isSubscriptionPrice ? 1 : 0.4,
        alignItems: "center",
        children: hasToggle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle/* Toggle */.Z, {
            isChecked: isSubscriptionPrice,
            onChange: onToggle,
            size: "small"
        })
    });
};
/* harmony default export */ var Checkout_PriceSwitch = (PriceSwitch);

;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/PriceSwitchRow.tsx







var PriceSwitchRow = function(param) {
    var onTogglePriceClick = param.onTogglePriceClick, item = param.item;
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        alignItems: "center",
        justifyContent: "space-between",
        mb: "16px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                textStyle: "body3",
                children: t("checkout:toggle-subscription-label")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkout_PriceSwitch, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                onToggle: function() {
                    return onTogglePriceClick(item);
                }
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/OTCItem.tsx
























var OTCItem = function(param) {
    var onTogglePriceClick = param.onTogglePriceClick, onToggleAutoRenew = param.onToggleAutoRenew, onQuantityChange = param.onQuantityChange, onOpenCancelModal = param.onOpenCancelModal, item = param.item, summary = param.summary, t = param.t, allowAction = param.allowAction;
    var ref;
    var price = item.price, product = item.product, type = item.type, oldOrder = item.oldOrder;
    var router = (0,next_router.useRouter)();
    var addSuffixCountry = (0,hooks/* useConfig */.ZR)().addSuffixCountry;
    var _metadata = product.metadata, requiresPrescription = _metadata.requires_prescription;
    var isRecurringPrice = (price === null || price === void 0 ? void 0 : price.type) === generated.StripePriceType.Recurring;
    var showQuantityInput = (0,react.useMemo)(function() {
        if (product.uniqName === generated.ProductNameType.FertilityHormoneTestKit) {
            return false;
        }
        if (!allowAction) {
            return false;
        }
        return type === generated.StripePriceType.OneTime.toUpperCase() && !requiresPrescription;
    }, [
        allowAction,
        product.uniqName,
        requiresPrescription,
        type
    ]);
    var showEditButton = (0,react.useMemo)(function() {
        if (product.uniqName === generated.ProductNameType.FertilityHormoneTestKit) {
            return false;
        }
        if ((oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.subId) && (oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.status) === generated.OrderStatus.Active) {
            return false;
        }
        if (showQuantityInput) {
            return false;
        }
        return true;
    }, [
        product.uniqName,
        oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.subId,
        oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.status,
        showQuantityInput
    ]);
    var handleSelectPrice = (0,react.useCallback)(function() {
        router.push((0,url_constants/* URL_EDIT_PRICE */.wT)(item.product.id, item.price.id));
    }, [
        item,
        router
    ]);
    var priceItemSummary = summary === null || summary === void 0 ? void 0 : (ref = summary.itemList) === null || ref === void 0 ? void 0 : ref.find(function(it) {
        return (it === null || it === void 0 ? void 0 : it.priceId) === (price === null || price === void 0 ? void 0 : price.id);
    });
    var subTotal = (priceItemSummary === null || priceItemSummary === void 0 ? void 0 : priceItemSummary.itemSubTotalAfterDiscount) || 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OrderSummaryItemWrapper/* OrderSummaryItemWrapper */.B, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummaryItemHeader/* OrderSummaryItemHeader */.t, {
                item: item
            }),
            allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    type === constants/* PRODUCT_TYPES.BOTH */.Pm.BOTH && !(0,lodash.isNil)(item === null || item === void 0 ? void 0 : item.isSubscriptionPrice) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceSwitchRow, {
                        item: item,
                        onTogglePriceClick: onTogglePriceClick
                    }),
                    isRecurringPrice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutoRefillToggle/* AutoRefillToggle */.f, {
                        mb: "16px",
                        isAutoRefill: item === null || item === void 0 ? void 0 : item.isAutoRenewal,
                        onToggle: function() {
                            return onToggleAutoRenew(item);
                        }
                    })
                ]
            }),
            showQuantityInput && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputCounter/* default */.Z, (0,_object_spread/* default */.Z)({
                onQuantityChange: onQuantityChange
            }, item)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                flexDirection: "column",
                bgColor: colors/* colors.grey.200 */.O.grey[200],
                p: 2,
                borderRadius: "sm",
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryItemWrapper/* SummaryItemWrapper */.Y, {
                        titleTranslation: t("product-price"),
                        value: (0,priceFormat/* formatPrice */.T)((0,utils/* getBasePrice */.HF)(subTotal)),
                        mb: 2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountryComponentWrapper/* CountryComponentWrapper */.$, {
                        countries: [
                            generated.RegionType.Sg,
                            generated.RegionType.Jp
                        ],
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryItemWrapper/* SummaryItemWrapper */.Y, {
                            titleTranslation: (0,checkCountry/* checkCountry */.d)([
                                generated.RegionType.Sg
                            ]) ? t("gst-fee", {
                                tax_percent: constants/* TAX_PERCENT */.bM[Countries/* CURRENT_COUNTRY */.Ho]
                            }) : t("vat-fee", {
                                tax_percent: constants/* TAX_PERCENT */.bM[Countries/* CURRENT_COUNTRY */.Ho]
                            }),
                            dataTranslation: (0,priceFormat/* formatPrice */.T)((0,utils/* getTax */.VT)(subTotal)),
                            mb: 1
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Divider */.iz, {
                        borderColor: colors/* colors.grey.500 */.O.grey[500],
                        borderWidth: "1px",
                        my: "16px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryItemWrapper/* SummaryItemWrapper */.Y, {
                        value: (0,priceFormat/* formatPrice */.T)(subTotal),
                        titleTranslation: t("".concat(addSuffixCountry("checkout"), ":due-now")),
                        textStyle: "body1"
                    })
                ]
            }),
            allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Divider */.iz, {
                        m: "16px 0px 8px 0px",
                        borderColor: colors/* colors.grey.500 */.O.grey[500]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        w: "100%",
                        justifyContent: "flex-end",
                        gap: "16px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, {
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrashcanIcon/* default */.Z, {}),
                                onClick: function() {
                                    return onOpenCancelModal(item);
                                }
                            }),
                            showEditButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, {
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditIcon/* default */.Z, {}),
                                onClick: handleSelectPrice
                            })
                        ]
                    })
                ]
            })
        ]
    }, item.price.id);
};
/* harmony default export */ var OrderSummary_OTCItem = (OTCItem);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./components/hooks/Localization/useProductLocalization.ts
var useProductLocalization = __webpack_require__(54653);
// EXTERNAL MODULE: ./src/configs/evaluations.ts
var evaluations = __webpack_require__(80621);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/constant/style.ts
var style = __webpack_require__(63102);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/OTCItemTeleConsultFee.tsx

















var OTCItemTeleConsultFee = function(param) {
    var onOpenCancelModal = param.onOpenCancelModal, item = param.item, platform = param.platform, allowAction = param.allowAction, summary = param.summary;
    var ref, ref1;
    var getTranslatedText = (0,useProductLocalization/* default */.Z)().getTranslatedText;
    var ref2 = (0,hooks/* useConfig */.ZR)(), country = ref2.country, addSuffixCountry = ref2.addSuffixCountry;
    var price = item.price, product = item.product, quantity = item.quantity;
    var id = product.id;
    var evalId = item.teleConsultForSkipEval || ((ref = item.completedEval) === null || ref === void 0 ? void 0 : ref.evalId);
    if (!evalId) {
        throw new Error("Invalid eval ID");
    }
    var evalTransKey = addSuffixCountry("eval");
    var ref3 = (0,esm/* useTranslation */.$G)([
        evalTransKey
    ]), evalTranslator = ref3.t;
    var t = (0,esm/* useTranslation */.$G)().t;
    var evalInfo = evaluations/* Evaluations */.Iq[country][platform].find(function(i) {
        return i.code === evalId;
    });
    var priceItemSummary = summary === null || summary === void 0 ? void 0 : (ref1 = summary.itemList) === null || ref1 === void 0 ? void 0 : ref1.find(function(it) {
        return (it === null || it === void 0 ? void 0 : it.priceId) === (price === null || price === void 0 ? void 0 : price.id);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OrderSummaryItemWrapper/* OrderSummaryItemWrapper */.B, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Image */.Ee, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, OrderSummaryItemHeader/* summaryItemImageProps */.s), {
                        src: "/assets/icons/".concat(evalInfo.icon, ".svg"),
                        borderRadius: "8px",
                        objectFit: "cover"
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                        justifyContent: "space-between",
                        flex: 1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                            ml: [
                                "16px"
                            ],
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                    textStyle: style/* PRODUCT_NAME_STYLE */.tJ,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm/* Trans */.cC, {
                                        components: {
                                            br: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                                        },
                                        children: t("".concat(addSuffixCountry("checkout"), ":skip-med-treatment"), {
                                            evaluation: evalTranslator(evalInfo.code)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                        display: "inline",
                                        textStyle: "body2",
                                        children: getTranslatedText(id, generated.StripeProductLocaleKeys.QuantityPerUnit)
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "body2",
                        children: "".concat(getTranslatedText(id, generated.StripeProductLocaleKeys.ProductName)).concat(quantity > 1 ? " x".concat(quantity) : "")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "body2semibold",
                        color: colors/* colors.grey.700 */.O.grey[700],
                        children: (0,priceFormat/* formatPrice */.T)((priceItemSummary === null || priceItemSummary === void 0 ? void 0 : priceItemSummary.itemSubTotalAfterDiscount) || 0)
                    })
                ]
            }),
            allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Divider */.iz, {
                        m: "16px 0px 8px 0px",
                        borderColor: colors/* colors.grey.500 */.O.grey[500]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                        w: "100%",
                        justifyContent: "flex-end",
                        gap: "16px",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, {
                            icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrashcanIcon/* default */.Z, {}),
                            onClick: function() {
                                return onOpenCancelModal(item);
                            }
                        })
                    })
                ]
            })
        ]
    }, item.price.id);
};

// EXTERNAL MODULE: ./components/Checkout/OrderSummary/CheckoutDueSection.tsx + 1 modules
var CheckoutDueSection = __webpack_require__(60599);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/PrescriptionItem.tsx




















var PrescriptionItem = function(param) {
    var onOpenCancelModal = param.onOpenCancelModal, onTogglePriceClick = param.onTogglePriceClick, onToggleAutoRenew = param.onToggleAutoRenew, onEditPriceClick = param.onEditPriceClick, item = param.item, summary = param.summary, t = param.t, allowAction = param.allowAction;
    var ref, ref1;
    var platform = (0,recoil_es/* useRecoilValue */.sJ)(states/* platformState */.QQ);
    var price = item.price, product = item.product, oldOrder = item.oldOrder, type = item.type;
    var _metadata = product.metadata, requiresPrescription = _metadata.requires_prescription;
    var isEDBundle = (0,utils/* isEDBundleProduct */.u7)(product);
    var addSuffixCountry = (0,hooks/* useConfig */.ZR)().addSuffixCountry;
    var checkoutTrans = addSuffixCountry("checkout");
    var ref2 = (0,react.useState)(false), openEDBundleInfo = ref2[0], setOpenEDBundleInfo = ref2[1];
    var isSecondOpinion = (oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.status) === generated.OrderStatus.PrescriptionRejected;
    var isRenewal = !(0,lodash.isEmpty)(oldOrder) && (oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.status) !== generated.OrderStatus.PrescriptionRejected;
    var isCancelledRenewal = isRenewal && (oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.isCancelled) === true;
    var isPrescription = requiresPrescription && (type === constants/* PRODUCT_TYPES.SUBSCRIPTION */.Pm.SUBSCRIPTION || type === constants/* PRODUCT_TYPES.ONE_TIME */.Pm.ONE_TIME);
    var isCovidConsult = (0,react.useMemo)(function() {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.evaluationId) === null || ref === void 0 ? void 0 : ref.noah) === generated.EvalIds.CovidTeleconsult;
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.evaluationId) === null || ref === void 0 ? void 0 : ref.noah
    ]);
    var showEditButton = (0,react.useMemo)(function() {
        if ((oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.subId) && (oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.status) === generated.OrderStatus.Active || isCovidConsult) {
            return false;
        }
        return true;
    }, [
        isCovidConsult,
        oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.status,
        oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.subId
    ]);
    var shouldChargeNow = (0,react.useMemo)(function() {
        return (0,utils/* checkShouldChargeNow */.xP)(product);
    }, [
        product
    ]);
    var isConsultOnly = (0,react.useMemo)(function() {
        var ref;
        var evalId = (ref = product.evaluationId) === null || ref === void 0 ? void 0 : ref[platform || generated.PlatformType.Noah];
        return (0,utils/* checkIsConsultOnly */.Pf)(evalId, product.uniqName);
    }, [
        product,
        platform
    ]);
    var isRxOneTime = (0,react.useMemo)(function() {
        return (0,utils/* checkIsRxOneTime */.kV)(product);
    }, [
        product
    ]);
    var priceItemSummary = summary === null || summary === void 0 ? void 0 : (ref1 = summary.itemList) === null || ref1 === void 0 ? void 0 : ref1.find(function(it) {
        return (it === null || it === void 0 ? void 0 : it.priceId) === (price === null || price === void 0 ? void 0 : price.id);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OrderSummaryItemWrapper/* OrderSummaryItemWrapper */.B, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummaryItemHeader/* OrderSummaryItemHeader */.t, {
                item: item
            }),
            type === constants/* PRODUCT_TYPES.BOTH */.Pm.BOTH && allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceSwitchRow, {
                item: item,
                onTogglePriceClick: onTogglePriceClick
            }),
            !isConsultOnly && !isRxOneTime && allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutoRefillToggle/* AutoRefillToggle */.f, {
                mb: "16px",
                isAutoRefill: item === null || item === void 0 ? void 0 : item.isAutoRenewal,
                onToggle: function() {
                    return onToggleAutoRenew(item);
                }
            }),
            (isPrescription && (0,lodash.isEmpty)(oldOrder) || isCancelledRenewal && isPrescription || isSecondOpinion) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutDueSection/* default */.Z, {
                price: (priceItemSummary === null || priceItemSummary === void 0 ? void 0 : priceItemSummary.itemSubTotalAfterDiscount) || 0,
                shouldChargeNow: shouldChargeNow,
                isEDBundle: isEDBundle
            }),
            allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Divider */.iz, {
                        m: "16px 0px 8px 0px",
                        borderColor: colors/* colors.grey.500 */.O.grey[500]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        w: "100%",
                        justifyContent: "flex-end",
                        gap: "16px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, {
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrashcanIcon/* default */.Z, {}),
                                onClick: function() {
                                    onOpenCancelModal(item);
                                }
                            }),
                            !shouldChargeNow && showEditButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* OFIconButton */.d, {
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditIcon/* default */.Z, {}),
                                onClick: function() {
                                    return onEditPriceClick(item);
                                }
                            })
                        ]
                    })
                ]
            }),
            isEDBundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* OFModal */.TH, {
                isOpen: openEDBundleInfo,
                onClose: function() {
                    setOpenEDBundleInfo(false);
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: "h4",
                            borderBottom: "1px solid ".concat(colors/* colors.grey.500 */.O.grey[500]),
                            children: t("".concat(checkoutTrans, ":ed-trial-bundle-info.title"))
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: "body1",
                            mt: "24px",
                            children: t("".concat(checkoutTrans, ":ed-trial-bundle-info.description"))
                        })
                    ]
                })
            })
        ]
    }, item.price.id);
};
/* harmony default export */ var OrderSummary_PrescriptionItem = (PrescriptionItem);

// EXTERNAL MODULE: ./components/Checkout/OrderSummary/SummarySection.tsx + 1 modules
var SummarySection = __webpack_require__(62683);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/PricesSection.tsx

















// THANH TODO Refactor hook
var PricesSection = function(param) {
    var t = param.t, summary = param.summary, items = param.items, allowAction = param.allowAction, shouldShowCashback = param.shouldShowCashback;
    var ref;
    var platform = (0,recoil_es/* useRecoilValue */.sJ)(states/* platformState */.QQ);
    var ref1 = (0,useCartHooks/* default */.ZP)(), onRemoveItemClick = ref1.onRemoveItemClick, onOpenCancelModal = ref1.onOpenCancelModal, onTogglePriceClick = ref1.onTogglePriceClick, onQuantityChange = ref1.onQuantityChange, onToggleAutoRenew = ref1.onToggleAutoRenew, onEditPriceClick = ref1.onEditPriceClick, cart = ref1.cart, hasUnpaidTextConsult = ref1.hasUnpaidTextConsult;
    var isRenewal = !!(cart === null || cart === void 0 ? void 0 : (ref = cart.cartItems) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        var ref, ref1, ref2;
        return !(0,lodash.isEmpty)(item === null || item === void 0 ? void 0 : item.oldOrder) && (item === null || item === void 0 ? void 0 : (ref = item.oldOrder) === null || ref === void 0 ? void 0 : ref.status) !== generated.OrderStatus.PrescriptionRejected && (item === null || item === void 0 ? void 0 : (ref1 = item.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : ref2.requires_prescription);
    }));
    var isAllConsultOnly = (0,react.useMemo)(function() {
        return items.every(function(i) {
            var ref;
            var product = i.product;
            var evalId = (ref = product.evaluationId) === null || ref === void 0 ? void 0 : ref[platform || generated.PlatformType.Noah];
            return (0,utils/* checkIsConsultOnly */.Pf)(evalId, product.uniqName);
        });
    }, [
        items,
        platform
    ]);
    return items.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                direction: "column",
                overflow: "auto",
                children: items.map(function(item) {
                    var product = item.product;
                    var _metadata = product.metadata, requiresPrescription = _metadata.requires_prescription;
                    if ((0,Checkout_utils/* checkIsTeleConsultProduct */.y)(product)) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OTCItemTeleConsultFee, {
                            platform: platform,
                            item: item,
                            onOpenCancelModal: onOpenCancelModal,
                            allowAction: allowAction,
                            summary: summary
                        }, item.sysId);
                    }
                    if (!requiresPrescription) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, product.sysId);
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummary_PrescriptionItem, {
                        t: t,
                        item: item,
                        onOpenCancelModal: onOpenCancelModal,
                        onToggleAutoRenew: onToggleAutoRenew,
                        onTogglePriceClick: onTogglePriceClick,
                        onEditPriceClick: onEditPriceClick,
                        allowAction: allowAction,
                        summary: summary
                    });
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                direction: "column",
                overflow: "auto",
                children: items.map(function(item) {
                    var product = item.product;
                    var _metadata = product.metadata, requiresPrescription = _metadata.requires_prescription;
                    if ((0,Checkout_utils/* checkIsTeleConsultProduct */.y)(product)) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, product.sysId);
                    }
                    return !requiresPrescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummary_OTCItem, {
                        t: t,
                        item: item,
                        onOpenCancelModal: onOpenCancelModal,
                        onTogglePriceClick: onTogglePriceClick,
                        onToggleAutoRenew: onToggleAutoRenew,
                        onQuantityChange: onQuantityChange,
                        onEditPriceClick: onEditPriceClick,
                        allowAction: allowAction,
                        summary: summary
                    });
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummarySection/* default */.Z, {
                t: t,
                summary: summary,
                isRenewal: isRenewal,
                hideShipping: isAllConsultOnly,
                hasUnpaidTextConsult: hasUnpaidTextConsult,
                shouldShowCashback: shouldShowCashback
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_RemoveCartItemModal, {
                onConfirmClick: onRemoveItemClick
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WarningRenewModal/* default */.Z, {
                t: t
            }),
            allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceModal["default"], {
                isSuggestion: true
            })
        ]
    }) : null;
};
/* harmony default export */ var OrderSummary_PricesSection = (PricesSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./graphql/react-query/index.ts
var react_query = __webpack_require__(41562);
// EXTERNAL MODULE: ./src/utils/getNameProp.ts
var getNameProp = __webpack_require__(44873);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/PromotionSection.tsx



















var PromotionSection = function(param) {
    var t = param.t, summary = param.summary, items = param.items, _isCovidProd = param.isCovidProd, isCovidProd = _isCovidProd === void 0 ? false : _isCovidProd, _allowAction = param.allowAction, allowAction = _allowAction === void 0 ? true : _allowAction;
    var setOrderCalculation = (0,recoil_es/* useSetRecoilState */.Zl)(states/* orderCalculationState */.jJ);
    var ref = (0,_sliced_to_array/* default */.Z)((0,recoil_es/* useRecoilState */.FV)(states/* promoCodeState */.FZ), 2), promoCode = ref[0], setPromoCodeState = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,recoil_es/* useRecoilState */.FV)(states/* isPromotionDisabledState */.Qp), 2), isDisabled = ref1[0], setIsDisabled = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,recoil_es/* useRecoilState */.FV)(states/* isPromotionAppliedState */.GT), 2), isPromotionApplied = ref2[0], setIsPromotionApplied = ref2[1];
    var platform = (0,recoil_es/* useRecoilValue */.sJ)(states/* platformState */.QQ);
    var ref3;
    var ref4 = (0,react.useState)((ref3 = promoCode === null || promoCode === void 0 ? void 0 : promoCode.code) !== null && ref3 !== void 0 ? ref3 : ""), promoCodeValue = ref4[0], setPromoCodeValue = ref4[1];
    var ref5 = (0,react.useState)(""), errorMessage = ref5[0], setErrorMessage = ref5[1];
    var ref6 = (0,react.useState)(""), minSpend = ref6[0], setMinSpend = ref6[1];
    var ref7 = (0,react.useState)(""), disableCodeMessage = ref7[0], setDisableCodeMessage = ref7[1];
    var previousSuccessPromoCode = (0,react.useRef)("");
    var ref8 = (0,generated.useApplyPromotionCodeForCartMutation)(react_query/* default */.Z), applyPromotionCodeForCartMutation = ref8.mutateAsync, error = ref8.error, isLoading = ref8.isLoading;
    // temporary use to disable for shorterm renewal promo code
    var isAllowRenewalPromo = (0,react.useMemo)(function() {
        var hasRenewalOrder = items.some(function(order) {
            return !(0,fp.isNil)(order.oldOrder);
        });
        return hasRenewalOrder && platform === generated.PlatformType.Noah && (0,checkCountry/* checkCountry */.d)([
            generated.RegionType.Hk
        ]);
    }, [
        items,
        platform
    ]);
    var onApplyPromo = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, resultApplyPromo, result, minAmount;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (allowAction) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return applyPromotionCodeForCartMutation({
                        input: {
                            code: promoCodeValue
                        }
                    });
                case 5:
                    resultApplyPromo = _ctx.sent;
                    if (!error) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Can't apply promotion code for cart");
                case 8:
                    setIsPromotionApplied(true);
                    result = resultApplyPromo === null || resultApplyPromo === void 0 ? void 0 : resultApplyPromo.applyPromotionCodeForCart;
                    minAmount = result === null || result === void 0 ? void 0 : (ref = result.promotionCode) === null || ref === void 0 ? void 0 : (ref1 = ref.restrictions) === null || ref1 === void 0 ? void 0 : ref1.minimum_amount;
                    if (result && minAmount) setMinSpend((0,priceFormat/* formatPrice */.T)(Math.abs(minAmount)));
                    if (result === null || result === void 0 ? void 0 : result.errorCode) setErrorMessage(result.errorCode);
                    if (result === null || result === void 0 ? void 0 : result.promotionCode) setPromoCodeState(result.promotionCode);
                    if (result) setOrderCalculation(result.cart.calculation);
                    if (!result.errorCode) {
                        setErrorMessage("");
                        previousSuccessPromoCode.current = promoCodeValue;
                        if (result.promotionCode) {
                            setIsDisabled(true);
                        }
                    }
                    if (!(result === null || result === void 0 ? void 0 : result.promotionCode)) setErrorMessage("error-voucher-message");
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        allowAction,
        applyPromotionCodeForCartMutation,
        promoCodeValue,
        error,
        setIsPromotionApplied,
        setPromoCodeState,
        setOrderCalculation,
        setIsDisabled
    ]);
    /**
   * If has renew orders only => display message coupon-disable-for-renew-order
   * If has both renew & new orders => display message coupon-disable-for-mix-order
   * If no renew order => display promotion code input field
   * @param cartItems list of cartItems
   * @returns error message for coupon case
   */ var getDisableCodeMessage = (0,react.useCallback)(function(cartItems) {
        var result = "";
        // get all items in cart has oldOrder
        var oldOrders = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(val) {
            return val.oldOrder;
        });
        // all items have oldOrder => all are renewal orders
        if ((oldOrders === null || oldOrders === void 0 ? void 0 : oldOrders.length) === cartItems.length) {
            result = t("checkout:coupon-disable-for-renew-order");
        } else if (oldOrders.length > 0) {
            result = t("checkout:coupon-disable-for-mix-order");
        }
        return result;
    }, [
        t
    ]);
    var renderPromoLine = (0,react.useCallback)(function(type, orderSummary, promoCoupon) {
        var ref;
        var isCashback = type === "cashback";
        var promoAmount = isCashback ? orderSummary.cashbackEarned : orderSummary.discountAmountNow;
        var CashbackEarnedRate = promoCoupon === null || promoCoupon === void 0 ? void 0 : (ref = promoCoupon.metadata) === null || ref === void 0 ? void 0 : ref.CashbackEarnedRate;
        if (!promoAmount || !promoCoupon || isCashback && !CashbackEarnedRate) {
            return "";
        }
        var amountText = (0,priceFormat/* formatPrice */.T)(Math.abs(promoAmount));
        var promoPercentOff = promoCoupon === null || promoCoupon === void 0 ? void 0 : promoCoupon.percent_off;
        var finalPercentOff = isCashback ? CashbackEarnedRate ? +CashbackEarnedRate * 100 : null : promoPercentOff;
        var percentText = finalPercentOff ? t("checkout:percent-".concat(isCashback ? "cashback" : "off", "-label"), {
            percent_off: finalPercentOff
        }) : "";
        return "".concat(isCashback ? "+" : "-").concat(amountText, " ").concat(percentText);
    }, [
        t
    ]);
    var renderPromoDetailText = (0,react.useCallback)(function() {
        var promoTypes = [
            "discount",
            "cashback"
        ];
        var promoTexts = promoTypes.reduce(function(prev, cur) {
            var text = renderPromoLine(cur, summary, promoCode.coupon);
            if (text) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    text
                ]);
            }
            return (0,_to_consumable_array/* default */.Z)(prev);
        }, []);
        return promoTexts.join("\n");
    }, [
        summary,
        promoCode,
        renderPromoLine
    ]);
    (0,react.useEffect)(function() {
        if (promoCode) onApplyPromo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (isAllowRenewalPromo) return setDisableCodeMessage(null);
        setDisableCodeMessage(getDisableCodeMessage(items));
    }, [
        isAllowRenewalPromo,
        items,
        t,
        getDisableCodeMessage
    ]);
    var onResetPromo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var result, ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return applyPromotionCodeForCartMutation({
                            input: {
                                code: "",
                                previousCode: previousSuccessPromoCode.current
                            }
                        });
                    case 2:
                        result = _ctx.sent;
                        if (result === null || result === void 0 ? void 0 : result.applyPromotionCodeForCart) {
                            ;
                            setPromoCodeState(result.applyPromotionCodeForCart.promotionCode);
                            setOrderCalculation((ref = result.applyPromotionCodeForCart) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.calculation);
                            setIsDisabled(false);
                            setIsPromotionApplied(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onResetPromo() {
            return _ref.apply(this, arguments);
        };
    }();
    if ((items === null || items === void 0 ? void 0 : items.length) === 0) return null;
    if (disableCodeMessage) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            direction: "column",
            my: "12px"
        }, (0,getNameProp/* default */.Z)("disable-promo-section")), {
            bg: "primaryTwo.500",
            borderRadius: "8px",
            padding: "18px",
            mb: "20px",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                fontFamily: "body",
                fontSize: {
                    base: "md"
                },
                color: "white",
                children: disableCodeMessage
            })
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        my: "12px"
    }, (0,getNameProp/* default */.Z)("prescription-promo-section")), {
        children: [
            isCovidProd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                justifyContent: "space-between",
                fontWeight: "bold"
            }, (0,getNameProp/* default */.Z)("gst")), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        children: t("checkout:gst-label")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        children: t("checkout:gst-included-label")
                    })
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(input_dist_index_esm/* InputGroup */.BZ, {
                mt: [
                    isCovidProd ? "4" : undefined
                ],
                size: "md",
                bg: colors/* colors.white.default */.O.white["default"],
                borderRadius: "10px",
                height: "50px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_dist_index_esm/* Input */.II, {
                        placeholder: t("checkout:add-a-code-placeholder"),
                        border: "none",
                        borderRadius: "8px",
                        color: colors/* colors.orange.400 */.O.orange[400],
                        fontWeight: "bold",
                        _placeholder: {
                            color: "placeholderInDarkTextBox",
                            fontWeight: "bold",
                            fontSize: "sm"
                        },
                        height: "50px",
                        value: promoCodeValue,
                        onChange: function(event) {
                            setPromoCodeValue(event.target.value);
                            if (event.target.value === "" && isPromotionApplied) {
                                onResetPromo();
                            }
                        },
                        fontSize: "16px",
                        disabled: !allowAction
                    }),
                    allowAction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_dist_index_esm/* InputRightElement */.xH, {
                        width: "5.5rem",
                        height: "100%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_dist_index_esm/* Button */.zx, {
                            fontFamily: "graphik",
                            fontSize: "xs",
                            color: "white",
                            bg: colors/* colors.orange.400 */.O.orange[400],
                            size: "sm",
                            rounded: "2xl",
                            width: "65px",
                            isDisabled: isDisabled || (items === null || items === void 0 ? void 0 : items.length) === 0,
                            onClick: function() {
                                return onApplyPromo();
                            },
                            isLoading: isLoading,
                            children: isDisabled ? t("checkout:added-label") : t("checkout:add-label")
                        })
                    })
                ]
            }),
            isPromotionApplied && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: (0,fp.isNil)(promoCode) || errorMessage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                    textStyle: "body3",
                    mt: "8px",
                    children: t("checkout:".concat(errorMessage), {
                        minSpend: minSpend
                    })
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    mt: "8px",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: "body3",
                            children: t("checkout:promo-code-label")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: "body3",
                            align: "right",
                            children: renderPromoDetailText()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Divider */.iz, {
                m: "12px 0 0 0",
                borderColor: colors/* colors.grey.300 */.O.grey[300]
            })
        ]
    }));
};
/* harmony default export */ var OrderSummary_PromotionSection = (PromotionSection);

;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/CheckoutSummaryInfo.tsx












var CheckoutSummaryInfo = function(_param) {
    var summary = _param.summary, items = _param.items, _allowAction = _param.allowAction, allowAction = _allowAction === void 0 ? true : _allowAction, _shouldShowCashback = _param.shouldShowCashback, shouldShowCashback = _shouldShowCashback === void 0 ? true : _shouldShowCashback, props = (0,_object_without_properties/* default */.Z)(_param, [
        "summary",
        "items",
        "allowAction",
        "shouldShowCashback"
    ]);
    var t = (0,es/* useTranslation */.$G)([
        "prescription_checkout"
    ]).t;
    var isCovidProd = Countries/* CURRENT_COUNTRY */.Ho === generated.RegionType.Hk && items.length === 1 && items[0].product.evaluationId.noah === generated.EvalIds.CovidTeleconsult;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummary_PricesSection, {
                t: t,
                items: items,
                summary: summary,
                allowAction: allowAction,
                shouldShowCashback: shouldShowCashback
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummary_PromotionSection, {
                isCovidProd: isCovidProd,
                t: t,
                summary: summary,
                items: items,
                allowAction: allowAction
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DueNowRow/* DueNowRow */.t, {
                summary: summary
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CashbackMessage/* CashbackMessage */.l, {
                cashbackAmount: summary.cashbackEarned,
                mt: 2
            })
        ]
    }));
};


/***/ }),

/***/ 91444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ DueNowRow; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1922);
/* harmony import */ var design_system_components_OFText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92757);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49384);
/* harmony import */ var src_utils_priceFormat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69240);






var DueNowRow = function(param) {
    var summary = param.summary;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
        justifyContent: "space-between",
        my: "0px 12px",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_1__/* .OFText */ .o, {
                textStyle: "body1semibold",
                children: t("".concat((0,src_utils__WEBPACK_IMPORTED_MODULE_2__/* .addTransSuffixCountry */ .WZ)("checkout"), ":total-label"))
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_1__/* .OFText */ .o, {
                textStyle: "body1semibold",
                children: (0,src_utils_priceFormat__WEBPACK_IMPORTED_MODULE_3__/* .formatPrice */ .T)((summary === null || summary === void 0 ? void 0 : summary.totalNowAfterCashback) || 0)
            })
        ]
    });
};


/***/ }),

/***/ 56598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ summaryItemImageProps; },
/* harmony export */   "t": function() { return /* binding */ OrderSummaryItemHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23887);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var components_hooks_Localization_usePriceLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27338);
/* harmony import */ var components_hooks_Localization_useProductLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54653);
/* harmony import */ var design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92757);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12705);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64443);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49384);
/* harmony import */ var _constant_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63102);












var summaryItemImageProps = {
    h: {
        base: "60px",
        md: "60px"
    },
    w: {
        base: "60px",
        md: "60px"
    }
};
var OrderSummaryItemHeader = function(param) {
    var item = param.item, displayFrequency = param.displayFrequency;
    var getTranslatedText = (0,components_hooks_Localization_useProductLocalization__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().getTranslatedText;
    var getTranslatedTextForPrice = (0,components_hooks_Localization_usePriceLocalization__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().getTranslatedTextForPrice;
    var price = item.price, product = item.product, quantity = item.quantity;
    var platform = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .platformState */ .QQ);
    var image = product.image, id = product.id;
    var translatedTexts = getTranslatedTextForPrice(price === null || price === void 0 ? void 0 : price.id);
    var frequencyQuantity = translatedTexts === null || translatedTexts === void 0 ? void 0 : translatedTexts[graphql_generated__WEBPACK_IMPORTED_MODULE_4__.StripePriceLocaleKeys.FrequencyQuantityDisplay];
    var displayFrequencyField = displayFrequency || graphql_generated__WEBPACK_IMPORTED_MODULE_4__.StripePriceLocaleKeys.PriceFrequency;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
        mb: "16px",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Image */ .Ee, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, summaryItemImageProps), {
                src: (0,src_utils__WEBPACK_IMPORTED_MODULE_6__/* .getImageUrlFromImageModel */ ._H)(image, platform, true),
                borderRadius: "8px",
                objectFit: "cover"
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                justifyContent: "space-between",
                flex: 1,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                    ml: [
                        "16px"
                    ],
                    flexDirection: "column",
                    gap: "8px",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__/* .OFText */ .o, {
                            textStyle: _constant_style__WEBPACK_IMPORTED_MODULE_7__/* .PRODUCT_NAME_STYLE */ .tJ,
                            children: "".concat(getTranslatedText(id, graphql_generated__WEBPACK_IMPORTED_MODULE_4__.StripeProductLocaleKeys.ProductName)).concat(quantity > 1 ? " x".concat(quantity) : "")
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                            flexDirection: "column",
                            children: [
                                frequencyQuantity && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__/* .OFText */ .o, {
                                    textStyle: "body3",
                                    children: frequencyQuantity
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__/* .OFText */ .o, {
                                    textStyle: "body3",
                                    children: translatedTexts === null || translatedTexts === void 0 ? void 0 : translatedTexts[displayFrequencyField]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 89469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ OrderSummaryItemWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52269);
/* harmony import */ var src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44873);







var OrderSummaryItemWrapper = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        direction: "column",
        borderRadius: "8px",
        width: "100%"
    }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("order-item-order-summary"), props), {
        children: [
            children,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .iz, {
                m: "32px 0px 12px 0px",
                borderColor: src_colors__WEBPACK_IMPORTED_MODULE_0__/* .colors.grey[900] */ .O.grey[900]
            })
        ]
    }));
};


/***/ }),

/***/ 62683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OrderSummary_SummarySection; },
  "t": function() { return /* binding */ infoIconProps; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(833);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./components/Common/CountryComponentWrapper.tsx
var CountryComponentWrapper = __webpack_require__(8294);
// EXTERNAL MODULE: ./components/Dashboard/Cashback/CashbackModal.tsx
var CashbackModal = __webpack_require__(21666);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./design_system/icons/InfoEllipseIcon.tsx
var InfoEllipseIcon = __webpack_require__(54875);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/hooks/index.ts + 13 modules
var hooks = __webpack_require__(18467);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
// EXTERNAL MODULE: ./src/utils/getNameProp.ts
var getNameProp = __webpack_require__(44873);
// EXTERNAL MODULE: ./src/utils/priceFormat.ts + 1 modules
var priceFormat = __webpack_require__(69240);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/constant/style.ts
var style = __webpack_require__(63102);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/SummaryItem.tsx








var SummaryItem = function(_param) {
    var label = _param.label, value = _param.value, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "value",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                justifyContent: "space-between",
                my: "12px"
            }, props), {
                children: children || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: style/* LABEL_TEXT_STYLE */.Fj,
                            children: label
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: style/* VALUE_TEXT_STYLE */.Ee,
                            children: value
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Divider */.iz, {
                borderColor: colors/* colors.grey.300 */.O.grey[300]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/SummarySection.tsx
















var infoIconProps = {
    cursor: "pointer",
    size: 20,
    color: colors/* colors.grey.900 */.O.grey[900]
};
var SummarySection = function(param) {
    var t = param.t, summary = param.summary, isRenewal = param.isRenewal, hideShipping = param.hideShipping, hasUnpaidTextConsult = param.hasUnpaidTextConsult, _shouldShowCashback = param.shouldShowCashback, shouldShowCashback = _shouldShowCashback === void 0 ? true : _shouldShowCashback;
    var subTotalNow = summary.subTotalNow, shippingFee = summary.shippingFee, cashbackRedeemed = summary.cashbackRedeemed;
    var transCheckoutKey = (0,utils/* addTransSuffixCountry */.WZ)("checkout");
    var ref = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var addSuffixCountry = (0,hooks/* useConfig */.ZR)().addSuffixCountry;
    var consultFee = summary === null || summary === void 0 ? void 0 : summary.teleConsultFee;
    var hasConsultFee = consultFee > 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, {
        flexDirection: "column",
        children: [
            (hasConsultFee || isRenewal) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,getNameProp/* default */.Z)("order-item-summary-section")), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Flex */.kC, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: style/* LABEL_TEXT_STYLE */.Fj,
                            children: t("".concat(addSuffixCountry("checkout"), ":consult-fee-label"))
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Flex */.kC, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                            textStyle: style/* VALUE_TEXT_STYLE */.Ee,
                            color: hasUnpaidTextConsult ? null : colors/* colors.grey.700 */.O.grey[700],
                            children: (0,priceFormat/* formatPrice */.T)(consultFee || 0)
                        })
                    })
                ]
            }), "tele-consult"),
            !hideShipping && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryItem, (0,_object_spread/* default */.Z)({
                label: t("checkout:shipping-label"),
                value: shippingFee === 0 ? t("checkout:free-shipping-label") : "".concat((0,priceFormat/* formatPrice */.T)(shippingFee))
            }, (0,getNameProp/* default */.Z)("shipping-fee"))),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountryComponentWrapper/* CountryComponentWrapper */.$, {
                countries: [
                    generated.RegionType.Sg
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryItem, (0,_object_spread/* default */.Z)({
                    label: t("checkout:subtotal-label"),
                    value: (0,priceFormat/* formatPrice */.T)(subTotalNow)
                }, (0,getNameProp/* default */.Z)("subtotal")))
            }),
            shouldShowCashback && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,getNameProp/* default */.Z)("cashback-redeemed")), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Flex */.kC, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                textStyle: style/* LABEL_TEXT_STYLE */.Fj,
                                children: t("".concat(transCheckoutKey, ":cashback-redeemed"))
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoEllipseIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoIconProps), {
                                onClick: onOpen
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: style/* VALUE_TEXT_STYLE */.Ee,
                        children: (0,priceFormat/* formatPrice */.T)(cashbackRedeemed)
                    })
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CashbackModal/* CashbackModal */.w, {
                isOpen: isOpen,
                onClose: onClose
            })
        ]
    });
};
/* harmony default export */ var OrderSummary_SummarySection = (SummarySection);


/***/ }),

/***/ 63102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ VALUE_TEXT_STYLE; },
/* harmony export */   "Fj": function() { return /* binding */ LABEL_TEXT_STYLE; },
/* harmony export */   "tJ": function() { return /* binding */ PRODUCT_NAME_STYLE; }
/* harmony export */ });
/* unused harmony exports ICON_STYLES, WARN_ICON_STYLES */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var ICON_STYLES = {
    ml: "5px",
    color: "primaryTwo.500",
    h: "20px",
    w: "20px",
    cursor: "pointer",
    fontSize: "16px"
};
var WARN_ICON_STYLES = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, ICON_STYLES), {
    color: "primary.900"
});
var PRODUCT_NAME_STYLE = "h5";
var LABEL_TEXT_STYLE = "body2";
var VALUE_TEXT_STYLE = "body2semibold";


/***/ }),

/***/ 46653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var design_system_components_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73451);
/* harmony import */ var design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92757);
/* harmony import */ var src_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52269);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64443);









var WarningReNewModal = function(param) {
    var t = param.t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .isWarningRenewModalOpenedState */ .qe), 2), isWarningRenewModalOpened = ref[0], setIsWarningRenewModalOpened = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(design_system_components_Modal__WEBPACK_IMPORTED_MODULE_2__/* .OFModal */ .TH, {
        onClose: function() {
            setIsWarningRenewModalOpened(false);
        },
        isOpen: isWarningRenewModalOpened,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
            justifyContent: "center",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__/* .OFText */ .o, {
                    textStyle: "h4",
                    borderBottom: "1px solid ".concat(src_colors__WEBPACK_IMPORTED_MODULE_4__/* .colors.grey[500] */ .O.grey[500]),
                    children: t("checkout:warning-modal-renew.title")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                    whiteSpace: "pre-line",
                    fontSize: {
                        base: "md"
                    },
                    textAlign: "left",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__/* .OFText */ .o, {
                            textStyle: "body1",
                            mt: "24px",
                            mb: "5px",
                            children: t("checkout:warning-modal-renew.p1")
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_3__/* .OFText */ .o, {
                            textStyle: "body1",
                            children: t("checkout:warning-modal-renew.p2")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(WarningReNewModal));


/***/ }),

/***/ 76842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CURRENCY; },
/* harmony export */   "y": function() { return /* binding */ checkIsTeleConsultProduct; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var opsComponents_subsOrders_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50340);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12705);
/* harmony import */ var src_constants_Countries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73252);




var _obj;
var CURRENCY_BY_COUNTRY = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, graphql_generated__WEBPACK_IMPORTED_MODULE_1__.RegionType.Sg, "$"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, graphql_generated__WEBPACK_IMPORTED_MODULE_1__.RegionType.Hk, "HK$"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, graphql_generated__WEBPACK_IMPORTED_MODULE_1__.RegionType.Jp, "\xa5"), _obj);
var CURRENCY = CURRENCY_BY_COUNTRY[src_constants_Countries__WEBPACK_IMPORTED_MODULE_2__/* .CURRENT_COUNTRY */ .Ho];
var checkIsTeleConsultProduct = function(product) {
    if (!product) {
        return false;
    }
    return opsComponents_subsOrders_constants__WEBPACK_IMPORTED_MODULE_0__/* .TELE_CONSULT_PRODUCT.includes */ .d.includes(product.uniqName);
};


/***/ }),

/***/ 96165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81285);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48641);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4480);
/* harmony import */ var components_PriceSelection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86161);
/* harmony import */ var components_hooks_Cart_useCartHooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95979);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12705);
/* harmony import */ var src_constants_Countries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73252);
/* harmony import */ var src_constants_Products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63213);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64443);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49384);
/* harmony import */ var src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44873);

















var ConsultTypes = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2877), __webpack_require__.e(8226)]).then(__webpack_require__.bind(__webpack_require__, 18226)).then(function(components) {
        return components.ConsultTypes;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18226)
            ];
        }
    }
});
var OTC_PRODUCTS = src_constants_Countries__WEBPACK_IMPORTED_MODULE_7__/* .CURRENT_COUNTRY */ .Ho === graphql_generated__WEBPACK_IMPORTED_MODULE_6__.RegionType.Sg ? src_constants_Products__WEBPACK_IMPORTED_MODULE_8__/* .OTC_PRODUCTS */ .OP : src_constants_Products__WEBPACK_IMPORTED_MODULE_8__/* .OTC_PRODUCTS_HK */ .sj;
var otcProductUniqueNames = OTC_PRODUCTS.map(function(product) {
    return src_constants_Products__WEBPACK_IMPORTED_MODULE_8__/* .STRIPE_PRODUCT_MAPPING */ .Zf[product];
}).filter(Boolean);
var PriceModal = function(param) {
    var onConfirmHandler = param.onConfirmHandler, isSuggestion = param.isSuggestion;
    var selectedProduct = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_9__/* .priceModalSelectedProductState */ .If);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_9__/* .priceModalSelectedPriceState */ .Hq), 2), selectedPrice = ref[0], setPreselectPrice = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_9__/* .selectedConsultTypeState */ .vo), 2), selectedConsultType = ref1[0], setSelectedConsultType = ref1[1];
    var isAdding = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_9__/* .isAddingCartState */ .G6);
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_9__/* .priceModalShowPriceStep */ .y), 2), showPriceSelectionStep = ref2[0], setShowPriceSelectionStep = ref2[1];
    var size = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .useBreakpointValue */ .Sx)({
        base: "full",
        md: "5xl"
    });
    var ref3 = (0,components_hooks_Cart_useCartHooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(isSuggestion), onConfirmPriceClick = ref3.onConfirmPriceClick, onClosePriceModal = ref3.onClosePriceModal, isModalOpened = ref3.isModalOpened;
    var onConfirm = function(item) {
        if (!isAdding) {
            if (onConfirmHandler) {
                onConfirmHandler(item);
            } else {
                onConfirmPriceClick(item, selectedConsultType);
            }
        }
        setPreselectPrice(null);
    };
    var onCloseModal = function() {
        if (!isAdding) {
            onClosePriceModal();
            // Reset the selected consult type
            setShowPriceSelectionStep(!(0,src_utils__WEBPACK_IMPORTED_MODULE_10__/* .checkIsCountryHaveTextConsult */ .nv)());
        }
        setPreselectPrice(null);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // If the selected product is OTC, show the price selection step (ignore the consultation type selection step)
        if (isModalOpened && selectedProduct && otcProductUniqueNames.includes(selectedProduct.uniqName)) {
            setShowPriceSelectionStep(true);
        }
    }, [
        selectedProduct,
        setShowPriceSelectionStep,
        isModalOpened
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Modal */ .u_, {
        onClose: onCloseModal,
        size: size,
        isOpen: isModalOpened,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            fallback: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)("div", {}),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .ModalOverlay */ .ZA, {}),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .ModalContent */ .hz, {
                    borderRadius: "0px",
                    margin: {
                        base: "0px",
                        md: "auto"
                    },
                    bg: "default.100",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .ModalCloseButton */ .ol, {
                            color: "primary.500",
                            fontSize: "xl",
                            zIndex: 1,
                            top: 4,
                            right: 4
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .ModalBody */ .fe, {
                            pt: {
                                base: "60px",
                                md: "60px"
                            },
                            pb: {
                                base: "60px",
                                md: "30px"
                            },
                            px: {
                                base: "30px",
                                md: "60px"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                justifyContent: "center"
                            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("price-modal-wrapper")), {
                                children: showPriceSelectionStep ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(components_PriceSelection__WEBPACK_IMPORTED_MODULE_4__/* .PriceSelection */ .h, {
                                    preselect: (selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.priceId) || "",
                                    productId: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id,
                                    autoProcess: false,
                                    onConfirm: onConfirm,
                                    isLoading: isAdding,
                                    onlyShowOTC: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNil)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isSubscriptionPrice) ? false : !(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isSubscriptionPrice)
                                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(ConsultTypes, {
                                    selectedType: selectedConsultType,
                                    onSelectType: setSelectedConsultType,
                                    onClickedNextBtn: function() {
                                        return setShowPriceSelectionStep(true);
                                    },
                                    shouldShowMoreInit: false
                                })
                            }))
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(PriceModal));


/***/ }),

/***/ 21666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CashbackModal; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76395);
/* harmony import */ var design_system_components_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73451);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12705);
/* harmony import */ var src_constants_Locales__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38273);
/* harmony import */ var src_utils_checkCountry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42304);
/* harmony import */ var src_utils_getLocaleTypeByCountry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15775);







var CashbackModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)([
        "wallet"
    ]).t;
    var transNoahPointKey = "wallet:noah-points-popup";
    var title = (0,src_utils_checkCountry__WEBPACK_IMPORTED_MODULE_4__/* .checkCountry */ .d)([
        graphql_generated__WEBPACK_IMPORTED_MODULE_2__.RegionType.Jp
    ]) ? t("".concat(transNoahPointKey, ":title")) : t("cashback-modal-title");
    var description = (0,src_utils_checkCountry__WEBPACK_IMPORTED_MODULE_4__/* .checkCountry */ .d)([
        graphql_generated__WEBPACK_IMPORTED_MODULE_2__.RegionType.Jp
    ]) ? t("".concat(transNoahPointKey, ":content")) : t("wallet:".concat((0,src_utils_getLocaleTypeByCountry__WEBPACK_IMPORTED_MODULE_5__/* .getLocaleTypeByCountry */ .P)(src_constants_Locales__WEBPACK_IMPORTED_MODULE_3__/* .LOCALE_ITEM.region */ .B.region), "-cashback-modal-description"));
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(design_system_components_Modal__WEBPACK_IMPORTED_MODULE_1__/* .InfoModal */ .nv, {
        isOpen: isOpen,
        onClose: onClose,
        title: title,
        body: description,
        size: "md"
    });
};


/***/ }),

/***/ 92866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ SummaryItemWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var design_system_components_OFText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92757);






var SummaryItemWrapper = function(_param) {
    var titleTranslation = _param.titleTranslation, dataTranslation = _param.dataTranslation, children = _param.children, value = _param.value, textStyle = _param.textStyle, color = _param.color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "titleTranslation",
        "dataTranslation",
        "children",
        "value",
        "textStyle",
        "color"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            justifyContent: "space-between",
            alignItems: "center"
        }, props), {
            children: [
                children || /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_0__/* .OFText */ .o, {
                    textStyle: textStyle || "body2",
                    children: titleTranslation
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(design_system_components_OFText__WEBPACK_IMPORTED_MODULE_0__/* .OFText */ .o, {
                    textStyle: textStyle || "body2",
                    color: color,
                    children: value || dataTranslation
                })
            ]
        }))
    });
};


/***/ }),

/***/ 30831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Toggle; },
  "j": function() { return /* reexport */ Toggle_ToggleCheckbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./design_system/icons/TickIcon.tsx
var TickIcon = __webpack_require__(26823);
// EXTERNAL MODULE: ./design_system/icons/ExitIcon.tsx
var ExitIcon = __webpack_require__(28329);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/theme.ts
var theme = __webpack_require__(10668);
;// CONCATENATED MODULE: ./design_system/components/Toggle/ToggleCheckbox.tsx








var ToggleCheckbox = function(_param) {
    var _isChecked = _param.isChecked, isChecked = _isChecked === void 0 ? false : _isChecked, onChange = _param.onChange, disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isChecked",
        "onChange",
        "disabled"
    ]);
    var CustomIcon = isChecked ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TickIcon/* default */.Z, {
        size: 32,
        color: colors/* colors.white.default */.O.white["default"]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExitIcon/* default */.Z, {
        size: 32,
        color: colors/* colors.white.default */.O.white["default"]
    });
    var bgColor = disabled ? colors/* colors.grey.300 */.O.grey[300] : isChecked ? colors/* colors.primary */.O.primary : colors/* colors.black.700 */.O.black[700];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        w: "40px",
        h: "40px",
        borderRadius: theme/* default.borderRadius.default */.ZP.borderRadius["default"],
        bg: bgColor,
        cursor: disabled ? "default" : "pointer",
        onClick: function() {
            return !disabled && onChange(!isChecked);
        }
    }, props), {
        children: CustomIcon
    }));
};
/* harmony default export */ var Toggle_ToggleCheckbox = (ToggleCheckbox);

// EXTERNAL MODULE: ./node_modules/react-switch/index.js
var react_switch = __webpack_require__(59936);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
;// CONCATENATED MODULE: ./design_system/components/Toggle/Toggle.tsx






var TOGGLE_SIZES = {
    large: {
        width: 100,
        height: 40,
        handleDiameter: 30,
        margin: "10px"
    },
    small: {
        width: 68,
        height: 32,
        handleDiameter: 20,
        margin: "8px"
    }
};
var TEXT_STYLES = {
    large: {
        textStyle: "button1"
    },
    small: {
        textStyle: "button2"
    }
};
var Toggle = function(param) {
    var isChecked = param.isChecked, onChange = param.onChange, _size = param.size, size = _size === void 0 ? "large" : _size, _onText = param.onText, onText = _onText === void 0 ? "ON" : _onText, _offText = param.offText, offText = _offText === void 0 ? "OFF" : _offText, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var styles = TOGGLE_SIZES[size];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], (0,_object_spread/* default */.Z)({
        onChange: onChange,
        checked: isChecked,
        onHandleColor: colors/* colors.orange.400 */.O.orange[400],
        offHandleColor: colors/* colors.grey.700 */.O.grey[700],
        offColor: colors/* colors.grey.300 */.O.grey[300],
        onColor: colors/* colors.grey.300 */.O.grey[300],
        disabled: disabled,
        uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
            alignItems: "center",
            h: "100%",
            w: "100%",
            justifyContent: "flex-end",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                textStyle: TEXT_STYLES[size].textStyle,
                color: colors/* colors.black.900 */.O.black[900],
                mr: styles.margin,
                children: offText
            })
        }),
        checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
            alignItems: "center",
            h: "100%",
            w: "100%",
            justifyContent: "flex-start",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                textStyle: TEXT_STYLES[size].textStyle,
                color: colors/* colors.black.900 */.O.black[900],
                ml: styles.margin,
                children: onText
            })
        }),
        activeBoxShadow: "transparent",
        draggable: false
    }, size === "large" && {
        uncheckedHandleIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
            h: "30px",
            w: "40px",
            bg: colors/* colors.grey.700 */.O.grey[700],
            borderRadius: "16px"
        }),
        checkedHandleIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
            h: "30px",
            w: "40px",
            bg: colors/* colors.orange.400 */.O.orange[400],
            borderRadius: "16px",
            ml: "-10px"
        })
    }, styles));
};

;// CONCATENATED MODULE: ./design_system/components/Toggle/index.ts





/***/ }),

/***/ 40728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);




var SvgEditIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")")
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M21.966 12.842a.17.17 0 0 0-.241 0L9.567 25l-.075.075a.511.511 0 0 0-.142.283l-.883 5.784a.362.362 0 0 0 .408.408l5.783-.883a.511.511 0 0 0 .284-.142l.075-.075 12.158-12.158a.171.171 0 0 0 0-.242l-5.2-5.2-.009-.008ZM31.517 12.442c0-.442-.192-.867-.5-1.184L28.74 8.983a1.716 1.716 0 0 0-1.183-.5l-1.233-.025a.522.522 0 0 0-.375.15l-2.367 2.367a.171.171 0 0 0 0 .242l5.2 5.2a.171.171 0 0 0 .242 0l2.367-2.367c.1-.1.15-.233.15-.375l-.026-1.233Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEditIcon);


/***/ }),

/***/ 65986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);




var SvgMinusIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        style: {
            WebkitTransform: "scale(".concat(size / 40, ")")
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M31.025 17.942H8.975a.517.517 0 0 0-.516.516v3.084c0 .285.23.516.516.516h22.05a.517.517 0 0 0 .517-.516v-3.084a.517.517 0 0 0-.517-.516Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgMinusIcon);


/***/ }),

/***/ 87949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);




var SvgPlusIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        style: {
            WebkitTransform: "scale(".concat(size / 40, ")")
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M31.025 17.942h-8.083a3.614 3.614 0 0 0-.4-.484 3.62 3.62 0 0 0-.484-.4V8.975a.52.52 0 0 0-.516-.517H18.45a.52.52 0 0 0-.517.517v8.083a3.62 3.62 0 0 0-.483.4c-.15.15-.283.317-.4.484H8.975a.52.52 0 0 0-.516.516v3.092a.52.52 0 0 0 .516.517h8.083c.117.166.25.333.4.483.15.15.317.283.484.4v8.083a.52.52 0 0 0 .517.517h3.091a.52.52 0 0 0 .517-.517V22.95c.166-.117.333-.25.483-.4.15-.15.284-.317.4-.483h8.084a.52.52 0 0 0 .516-.517v-3.092a.52.52 0 0 0-.517-.516h-.008Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPlusIcon);


/***/ }),

/***/ 76013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);




var SvgTrashcanIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        style: {
            WebkitTransform: "scale(".concat(size / 40, ")")
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M31.025 10.4H25.79V8.975a.52.52 0 0 0-.516-.517H14.708a.52.52 0 0 0-.517.517V10.4H8.958a.52.52 0 0 0-.517.517v3.066c0 .092.075.175.175.175h22.742a.176.176 0 0 0 .175-.175v-3.066a.52.52 0 0 0-.517-.517h.009ZM28.075 16.642h-16.15a.176.176 0 0 0-.176.175v14.208a.52.52 0 0 0 .517.517h15.467a.52.52 0 0 0 .517-.517V16.817a.176.176 0 0 0-.175-.175ZM21.14 27.433c0 .192-.15.342-.341.342h-1.592a.338.338 0 0 1-.342-.342V20.4c0-.192.15-.342.342-.342h1.591c.192 0 .342.15.342.342v7.033Z",
            fill: color || "#F7F6F5"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgTrashcanIcon);


/***/ }),

/***/ 50340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ TELE_CONSULT_PRODUCT; }
/* harmony export */ });
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12705);

var TELE_CONSULT_PRODUCT = [
    graphql_generated__WEBPACK_IMPORTED_MODULE_0__.ProductNameType.Teleconsultation,
    graphql_generated__WEBPACK_IMPORTED_MODULE_0__.ProductNameType.TeleconsultNoEval
];


/***/ }),

/***/ 38273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LOCALE_ITEM; },
/* harmony export */   "d": function() { return /* binding */ LOCALE_TYPE_BY_COUNTRY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12705);


var LOCALE_ITEM = {
    region: "region",
    region_time: "region_time",
    delivery_time_slots: "delivery_time_slots"
};
var _obj, _obj1, _obj2, _obj3;
var LOCALE_TYPE_BY_COUNTRY = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, graphql_generated__WEBPACK_IMPORTED_MODULE_0__.RegionType.Sg, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, LOCALE_ITEM.region, "sg"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, LOCALE_ITEM.region_time, "singapore_time"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, LOCALE_ITEM.delivery_time_slots, "3_hour_delivery"), _obj)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, graphql_generated__WEBPACK_IMPORTED_MODULE_0__.RegionType.Hk, (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, LOCALE_ITEM.region, "hk"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, LOCALE_ITEM.region_time, "hongkong_time"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, LOCALE_ITEM.delivery_time_slots, "2_hour_delivery"), _obj1)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, graphql_generated__WEBPACK_IMPORTED_MODULE_0__.RegionType.Jp, (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, LOCALE_ITEM.region, "jp"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, LOCALE_ITEM.region_time, "japan_time"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, LOCALE_ITEM.delivery_time_slots, "2_hour_delivery"), _obj2)), _obj3);


/***/ }),

/***/ 10668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W0": function() { return /* binding */ spacing; }
/* harmony export */ });
/* unused harmony exports borderRadius, shadow, theme */
// THIS IS FROM CHAKRA https://chakra-ui.com/docs/styled-system/theme#spacing
var spacing = {
    1: "0.25rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};
var borderRadius = {
    radii: {
        none: "0",
        sm: "0.125rem",
        base: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
    }
};
var shadow = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1),0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1),0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,rgba(0, 0, 0, 0.2) 0px 5px 10px,rgba(0, 0, 0, 0.4) 0px 15px 40px",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)"
};
var theme = {
    borderRadius: {
        default: "8px"
    },
    fonts: {
        default: "Graphik"
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 15775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getLocaleTypeByCountry; }
/* harmony export */ });
/* harmony import */ var src_constants_Countries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73252);
/* harmony import */ var src_constants_Locales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38273);


var getLocaleTypeByCountry = function(itemName) {
    var ref;
    return (ref = src_constants_Locales__WEBPACK_IMPORTED_MODULE_1__/* .LOCALE_TYPE_BY_COUNTRY */ .d[src_constants_Countries__WEBPACK_IMPORTED_MODULE_0__/* .CURRENT_COUNTRY */ .Ho]) === null || ref === void 0 ? void 0 : ref[itemName];
};


/***/ })

}]);